import { BryntumButton, BryntumTextField } from "@bryntum/schedulerpro-react";
import { useEffect, useCallback, useState, useContext, useRef } from "react";
import BryntumContext from "../context/bryntumContext.jsx";

const SwivuSearchBar = ({ searchableRefs }) => {
    const searchFieldRef = useRef(null);
    const [found, setFound] = useState({});
    const [totalHits, setTotalHits] = useState(0);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [currentCmpIndex, setCurrentCmpIndex] = useState(0);
    const { searchBarVisible } = useContext(BryntumContext);

    useEffect(() => {
        if (searchFieldRef.current) {
            if (!searchBarVisible) {
                searchFieldRef.current.instance.clear();
            }
            else {
                searchFieldRef.current.instance.focus();
            }
        }
    }, [searchFieldRef, searchBarVisible]);

    const onChange = useCallback(({ value }) => {
        if (!value) {
            setTotalHits(0);
            searchableRefs.forEach(ref => {
                ref.current.instance.features.search.clear();
            });
        }
        else {
            Promise.all(searchableRefs.map(ref => {
                return ref.current.instance.features.search.search(value, false);
            })).then(results => {
                let counter = 0;
    
                setFound(
                    Object.fromEntries(
                        results.map((result, index) => {
                            counter += result.length;
    
                            return [searchableRefs[index].current.instance.id, result];
                        })
                    )
                );
    
                setTotalHits(counter);
            });
        }
    }, [searchableRefs, found]);

    const goToNext = useCallback(() => {
        let index = currentIndex + 1;
        let cmpIndex = currentCmpIndex;

        let { instance } = searchableRefs[cmpIndex].current;

        // If we reached end of the current list, reset counters, move to next
        if (found[instance.id].length === index) {
            index = 0;
            cmpIndex = (cmpIndex + 1) % searchableRefs.length;
            instance = searchableRefs[cmpIndex].current.instance;
        }

        setCurrentIndex(index);
        setCurrentCmpIndex(cmpIndex);
        
        instance.features.search.gotoHit(index);
    }, [found, searchableRefs, currentIndex, currentCmpIndex]);
    
    const goToPrev = useCallback(() => {
        let index = currentIndex - 1;
        let cmpIndex = currentCmpIndex;

        let { instance } = searchableRefs[cmpIndex].current;

        // If we reached end of the current list, reset counters, move to next
        if (index < 0) {
            cmpIndex = (cmpIndex + 1) % searchableRefs.length;
            instance = searchableRefs[cmpIndex].current.instance;
            index = found[instance.id].length - 1;
        }

        setCurrentIndex(index);
        setCurrentCmpIndex(cmpIndex);
        
        instance.features.search.gotoHit(index);
    }, [found, searchableRefs, currentIndex, currentCmpIndex]);

    // Using Bryntum components for unified appearance
    return searchBarVisible ? <div>
        <div className="flex flex-row gap-x-2 m-3">
            <BryntumTextField
                ref={searchFieldRef}
                clearable={true}
                onInput={onChange}
                onClear={() => onChange({ value: '' })}
                badge={totalHits && searchBarVisible ? totalHits : null}
            />
            <BryntumButton
                icon="b-fa-angle-up"
                onClick={goToPrev}
            />
            <BryntumButton
                icon="b-fa-angle-down"
                onClick={goToNext}
            />
        </div>
    </div>: null
}

export default SwivuSearchBar;
